// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__RIRFL","homeTitle":"Home_homeTitle__u8ZOw"};